$('.topic__viewmore').on('click', function(event) {
  var $self = $(event.currentTarget);
  var $block = $self.parents('.topic').find('.topic__showmore');

  if ( $self.hasClass('expanded') ) {
    $self.removeClass('expanded');
    $block.slideUp('medium', function() {
      $self.html('Toon meer');
    });
  } else {
    $self.addClass('expanded');
    $block.slideDown('medium', function(event) {
      $self.html('Toon minder');
    });
  }
});

$('.topicblock__tab').on('click', function(event) {
  var $self = $(event.currentTarget);
  var dataIndex = $self.attr('data-index');
  var index = parseInt($self.attr('data-index')) * 100;

  $('.topicblock__column').removeClass('current');

  if ( $self.hasClass('tab--big') ) {
    $('li.current').removeClass('current');
    $self.addClass('current');
  } else {
    $('span.current').removeClass('current');
    $self.find('span').addClass('current');
  }

  var $new = $('.topicblock__column[data-index=\'' + dataIndex + '\']');
  $new.addClass('current');

  $('.topicblock__container').animate({
    'right': index + '%',
  }, 450, 'easeInOutQuint');
});

$('.list__viewmore').on('click', function(event) {
  var $self = $(event.currentTarget);
  var $block = $self.parents('.user__topics').find('.list__expand');
  var $pagination = $self.parents('.user__topics').find('.pagination');
  if ( $self.hasClass('expanded') ) {
    $self.removeClass('expanded');
    $block.slideUp('medium', function(event) {
      $self.html('Toon meer');
    });
  } else {
    $self.addClass('expanded');
    $block.slideDown('medium', function() {
      $self.fadeOut();
      $pagination.slideDown();
    });
  }
});

$('.header__icon').on('click', function(event) {
  var $self = $(event.currentTarget);
  var $block = $self.closest('.topic').find('.topic__content');
  var $icon = $(event.currentTarget).find('i');

  if ( $self.hasClass('expanded') ) {
    $icon.css({'transform': 'rotate(180deg)'});
    $block.slideUp(500, 'easeOutQuad');
    $self.removeClass('expanded');
  } else {
    $icon.css({'transform': 'rotate(0deg)'});
    $block.slideDown(450, 'easeInOutQuad');
    $self.addClass('expanded');
  }
});
// Replaces # with ? on bookmark url on first page on topics;
var bookmark_url = $('#content > .thread > .thread__meta > .meta__right span > a.seoable-bookmark.ga-event');
if (bookmark_url.length && ~bookmark_url.attr('href').indexOf("bookmark=1") && !~bookmark_url.attr('href').indexOf("?")){
 bookmark_url.attr('href',bookmark_url.attr('href').replace('&','?'));
}